var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { keyframes } from "styled-components";
import Icon from "../icons/Icon";
import Box from "../box/Box";
const spinner = keyframes({
    to: {
        transform: "rotate(360deg)",
    },
});
const StyledIcon = styled(Icon).withConfig({ displayName: "StyledIcon_APC-7281-productShell", componentId: "sc-1pdeojn" }) `animation:${spinner} 1.4s linear infinite;font-size:${({ theme, variant }) => theme.textStyles[variant].fontSize};`;
const Spinner = (_a) => {
    var { size = "heading2" } = _a, rest = __rest(_a, ["size"]);
    return (React.createElement(Box, { mx: "auto", "aria-label": "loading", role: "alert", "aria-live": "polite", "aria-busy": "true" },
        React.createElement(StyledIcon, Object.assign({ name: "loading", variant: size }, rest))));
};
export default Spinner;
//# sourceMappingURL=Spinner.js.map